
import CrownBlocks from '../../../common.js';

document.addEventListener('DOMContentLoaded', function(event) {

    /**
	 * Open team member bio drawer on click
	 */
    const tm_blocks = document.querySelectorAll('.wp-block-crown-blocks-team-member-index');
	tm_blocks.forEach( (block, block_index) => {
        
        const team_members = block.querySelectorAll('.team-member');
        const drawers = block.querySelectorAll('.drawer');
        
        team_members.forEach( (team_member, tm_index) => {

            const team_member_link = team_member.children[0];
            
            team_member_link.addEventListener('click', e => {
                e.preventDefault();

                if ( team_member.classList.contains('active') ) {

                    // If team member is already active, close active drawer
                    team_member.classList.remove('active');
                    drawers.forEach(drawer => drawer.innerHTML = '');
                    
                } else {

                    // Remove active class from all team members and add it back to the clicked team member
                    team_members.forEach(tm => tm.classList.remove('active'));
                    team_member.classList.add('active');

                    // Empty any existing drawer content
                    drawers.forEach(drawer => drawer.innerHTML = '');

                    // Get content for team member bio
                    const bio = team_member.querySelector('.team-member__bio').innerHTML;
                    
                    // Loop through drawers and find the next visible one (set in CSS based on column count)
                    let nextVisibleDrawer = team_member.nextElementSibling;
                    while ( ! ( nextVisibleDrawer.classList.contains('drawer') && getComputedStyle(nextVisibleDrawer).display == 'block' ) ) {
                        nextVisibleDrawer = nextVisibleDrawer.nextElementSibling;
                    }

                    // Set drawer bio content
                    nextVisibleDrawer.innerHTML = '<div class="container"><div class="inner">' + bio + '<button class="drawer-close">Close Bio</button></div></div>';

                    const container = nextVisibleDrawer.children[0];
                    const containerHeight = getComputedStyle(container).height;

                    // Animate drawer opening
                    nextVisibleDrawer.animate([
                        // keyframes
                        { height: '0px' },
                        { height: containerHeight }
                    ], {
                        // timing options
                        duration: 400,
                        iterations: 1
                    });
                    
                }
                
            }, true);
        });

        /**
         * Close any active team member bios on close button click
         */
        drawers.forEach( (drawer, drawer_index) => {
            drawer.addEventListener('click', e => {
                if ( e.target && e.target.classList.contains('drawer-close') ) {

                    team_members.forEach(team_member => team_member.classList.remove('active'));
                    drawers.forEach(drawerTwo => drawerTwo.innerHTML = '');
                    
                }
            });
        });

        /**
         * Load more team members with "Load More" button if limit exists
         */
        var load_more = block.querySelector('.load-more');
        if ( load_more !== null && typeof load_more !== 'undefined' ) {
            load_more.addEventListener('click', e => {
                e.preventDefault();
                const button = e.target;

                const postsPerPage = parseInt( button.getAttribute('data-limit'), 10 );
                const hiddenTeamMembers = block.querySelectorAll('.team-member.hidden');

                setTimeout(() => {
                    if ( hiddenTeamMembers.length > postsPerPage ) {
                        for ( let i = 0; i < postsPerPage; i++ ) {
                            hiddenTeamMembers[i].classList.remove('hidden');
                        }
                    } else {
                        hiddenTeamMembers.forEach( (tm, tm_index) => {
                            tm.classList.remove('hidden');
                            button.parentElement.remove();
                        });
                    }
                }, 250);

            });
        }

        /**
         * Set drawer margins to touch the sides of the viewport. 
         * Normally we would do this in CSS, but being able to set page section widths to whatever you want kinda throws a wrench in that. 
         */
        const setDrawerMargins = CrownBlocks.debounce(() => {
            drawers.forEach((drawer, drawer_index) => {
                const drawerOffsetLeft = drawer.getBoundingClientRect().x;
                let drawerMarginLeft = drawer.style.marginLeft;
                drawerMarginLeft = ( typeof drawerMarginLeft === 'undefined' || drawerMarginLeft === '' ? 0 : parseInt( drawerMarginLeft, 10 ) );

                drawer.style.marginLeft = ( drawerMarginLeft - drawerOffsetLeft ) + 'px';
                drawer.style.marginRight = ( drawerMarginLeft - drawerOffsetLeft ) + 'px';
            });
        });
        setDrawerMargins();
        window.addEventListener('resize', setDrawerMargins);
        
	});
    
});
